import axios from "axios";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../../../components/Modal/Modal";
import useAuth from "../../../../hooks/useAuth";
import { BASE_URL } from "../../../../utils/Element";

const AddLeadTypeModal = ({ showModal, onClose, onCallApi }) => {
  const [config] = useAuth();
  const [error, setError] = useState({});
  const [disable, setDisable] = useState(false);

  const [data, setData] = useState({
    lease_type: "",
  });

  const handleChange = (value, name) => {
    setError((prev) => ({ ...prev, [name]: "" }));
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    onClose();
    setDisable(false);
    setError({});
    setData({
      lease_type: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);

    const dataToSend = {
      name: data.lease_type,
    };

    axios
      .post(`${BASE_URL}/add-lease-type`, dataToSend, config)
      .then((res) => {
        onCallApi();
        handleClose();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.errors || {});
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => {
        setDisable(false);
      });
  };

  return (
    <Modal title="Add Lease Type" show={showModal} onClose={handleClose}>
      <form className="mt-3" onSubmit={handleSubmit}>
        <div>
          <label className="block text-sm font-medium mb-1 dark-H">Lease Type</label>
          <input
            type="text"
            className="dark-H body-N w-full px-3 py-2"
            placeholder="Enter Lease Type"
            value={data.lease_type}
            onChange={(e) => handleChange(e.target.value, "lease_type")}
          />
          {error?.lease_type && (
            <p className="text-red-500 text-xs mt-1">{error.lease_type}</p>
          )}
        </div>

        <div className="mt-8 flex gap-4">
          <button
            type="submit"
            disabled={disable}
            className="save-button light-L head-5 green-bg-H"
          >
            {disable ? "Adding..." : "Add"}
          </button>
          <button type="button" onClick={handleClose} className="green-H">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddLeadTypeModal;